var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPipelineCardUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0831 5.99998C14.0831 3.79398 12.2519 1.99998 10 1.99998C7.74817 1.99998 5.91688 3.79398 5.91688 5.99998C5.91688 8.20599 7.74817 9.99998 10 9.99998C12.2519 9.99998 14.0831 8.20599 14.0831 5.99998ZM17.9458 20H16.1247C15.5612 20 15.1039 19.552 15.1039 19C15.1039 18.448 15.5612 18 16.1247 18H16.5626C17.269 18 17.7906 17.303 17.5232 16.662C16.287 13.698 13.3839 12 10 12C6.61613 12 3.71302 13.698 2.47685 16.662C2.20941 17.303 2.73104 18 3.43742 18H3.87532C4.43879 18 4.8961 18.448 4.8961 19C4.8961 19.552 4.43879 20 3.87532 20H2.05424C0.778267 20 -0.226182 18.857 0.044325 17.636C0.787453 14.277 3.10771 11.798 6.16392 10.673C4.76954 9.57396 3.87532 7.88999 3.87532 5.99998C3.87532 2.44898 7.02342 -0.381023 10.734 0.0419769C13.4227 0.347977 15.65 2.44693 16.0532 5.06993C16.4003 7.33094 15.4561 9.39596 13.8361 10.673C16.8923 11.798 19.2126 14.277 19.9557 17.636C20.2262 18.857 19.2218 20 17.9458 20ZM13.0624 19C13.0624 19.552 12.605 20 12.0416 20H7.95845C7.39498 20 6.93767 19.552 6.93767 19C6.93767 18.448 7.39498 18 7.95845 18H12.0416C12.605 18 13.0624 18.448 13.0624 19Z",
    fill: "#399E79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelineCardUserIcon);
export default __webpack_public_path__ + "static/media/PipelineCardUser-Icon.33d01c875f6606ca5322c01b1faed813.svg";
export { ForwardRef as ReactComponent };